import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Card } from 'primeng/card';
import { Button } from 'primeng/button';
import { Regulamin } from '../../../../../shared/models/regulamin';
import { Router } from '@angular/router';
import { APP_PATHS } from '../../../../../core/config/app-paths';
import { DatePipe } from '@angular/common';
import { SafeHtmlPipe } from '../../../../../shared/pipes/safe-html-pipe';

@Component({
  selector: 'app-admin-panel-rule-details-basic',
  imports: [Card, Button, DatePipe, SafeHtmlPipe],
  templateUrl: './admin-panel-rule-details-basic.html',
  styleUrl: './admin-panel-rule-details-basic.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelRuleDetailsBasic {
  rule = input.required<Regulamin>();
  readonly #router = inject(Router);

  protected readonly canEdit = computed(() => {
    const dataOd = this.rule().dataOd;

    if (!dataOd) {
      return false;
    }

    return new Date(dataOd).getTime() >= Date.now();
  });

  protected onBack(): void {
    this.#router.navigate([
      `/${APP_PATHS.admin.root}/${APP_PATHS.admin.rules}`,
    ]);
  }

  protected onEdit(): void {
    this.#router.navigate([
      `/${APP_PATHS.admin.root}/${APP_PATHS.admin.rules}/${this.rule()!.id}/${APP_PATHS.admin.edit}`,
    ]);
  }
}
